import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-file-description',
  templateUrl: './file-description.component.html',
  styleUrls: ['./file-description.component.sass']
})
export class FileDescriptionComponent implements OnInit {
  @Input() description: any;
  element: any; 

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.element = data; 
  }

  ngOnInit(): void {
    console.log('Elemento recebido:', this.element); 
  }
}
